module.exports = __webpack_public_path__ + "static/media/UniNeueBold.c3dde5f1.woff";